import React, { useState, useContext } from 'react';
import MainTitle from 'components/MainTitle';
import FormContainer from 'components/FormContainer';
import Fieldset from 'components/Fieldset';
import Legend from 'components/Legend';
import InputControl from 'components/InputControl';
import FormActions from 'components/FormActions';
import { Button, Text } from 'mondrian-react';
import Input from 'components/Input';
import Timer from 'components/Timer';
import { store } from '../../store.js';
import { changeEmail, SendToken } from 'core/api/changeEmail/changeEmailApi';
import Modal from 'components/Modal';
import Analytics from 'core/Utils/Analytics';

const TokenValidate = ({ setForm, formData, navigation, setIsLoading }) => {
  const { next } = navigation;
  const [token, setToken] = useState('');
  const [isDisabled, setDisabled] = useState(true);
  const [validForm, setValidForm] = useState(false);
  const { email } = formData;

  const logoutLink = process.env.REACT_APP_PING_AUTHORIZE;

  const globalState = useContext(store);
  const { state, dispatch } = globalState;

const userEmailText = state?.emailData?.changeEmail ? state?.emailData?.changeEmail : "seu e-mail" ;
  const userEmailSessionId = state?.emailData?.emailSessionId;

  const [modalContent, setModalContent] = useState(null);

  let buttonEmailText = userEmailText ? 'Alterar e-mail' : 'Cadastrar e-mail';
  const { accesstoken = 'undefined' } = state;

  async function handleSubmit(e) {
    e.preventDefault();

    setIsLoading(true);
    let result = await changeEmail(
      {
        sessionId: userEmailSessionId,
        token: token,
      },
      accesstoken
    );
    setIsLoading(false);

    let { error = null } = result;
    if (error != null) {
      const { message } = error?.warning;
      setModalContent(error);

      Analytics().setErrorEvent({
        eventAction: 'callback:alterar-email-token',
        eventLabel: message,
        code: error?.errorCode
      });
      if (result.code === 401) {
        setTimeout(function () {
          window.location.href = logoutLink;
        }, 2000);
      }
    } else {
      Analytics().setEvent({
        eventAction: 'callback:alterar-email-token',
        eventLabel: 'tentativa:sucesso',
      });

      dispatch({
        type: 'SET_EMAIL_DATA',
        payload: { newEmail: userEmailText },
      });

      next();
    }
  }

  function tokenValidate(value) {
    setToken(value);
    if (value.length === 6) {
      setValidForm(true);
    } else {
      setValidForm(false);
    }
  }

  async function resendtoken() {
    setDisabled(true);
    setIsLoading(true);
    let result = await SendToken(
      {
        newEmail: userEmailText,
      },
      accesstoken
    );
    let { error = null } = result;
    if (error != null) {
      const { message } = error?.warning;
      setModalContent(error);

      Analytics().setErrorEvent({
        eventAction: 'callback:alterar-email-reenvio-token',
        eventLabel: message,
        code: error?.errorCode
      });
      if (result.code === 401) {
        setTimeout(function () {
          window.location.href = logoutLink;
        }, 2000);
      }
    } else {
      // Analytics().setEvent({
      //   eventAction: "callback:alterar-email-reenvio-token",
      //   eventLabel: "tentativa:sucesso",
      // });

      dispatch({
        type: "SET_EMAIL_DATA",
        payload: { emailSessionId: result?.data?.sessionId, changeEmail: userEmailText },
      });
    }
    setIsLoading(false);
  }
  function onRequestClose(data = {}) {
    setModalContent(null);
  }
  return (
    <>
      {modalContent && (
        <Modal onClose={onRequestClose} content={modalContent} />
      )}
      <FormContainer onSubmit={handleSubmit}>
        <MainTitle sm>{buttonEmailText}</MainTitle>
        <Legend>
          <Text>
            Estamos quase terminando. Enviamos um código de verificação para
            {' ' + userEmailText}. Insira no campo abaixo:
          </Text>
        </Legend>
        <Fieldset>
          <InputControl>
            <Input
              label="Codigo de Verificação"
              name="inputToken"
              id="inputToken"
              mask={'999999'}
              type="text"
              maskChar=""
              onChange={(e) => tokenValidate(e.target.value)}
            />
          </InputControl>
          <FormActions>
            <Button type="submit" block disabled={!validForm}>
              Confirmar
            </Button>
            <Button
              type="button"
              disabled={isDisabled}
              onClick={resendtoken}
              secondary
              block
            >
              Reenviar código de verificação
            </Button>
            {isDisabled && (
              <Timer
                timer={30}
                callback={() => setDisabled(false)}
                text="Aguarde %timer% segundos para reenviar o código"
              />
            )}
          </FormActions>
        </Fieldset>
      </FormContainer>
    </>
  );
};

export default TokenValidate;
